import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import SubscribePage from './SubscribePage';
import WorkspacesPage from './WorkspacesPage';
import RemotePage from './RemotePage';
import WorkspaceDetailPage from './WorkspaceDetailPage';
import InstallPrompt from './InstallPrompt';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/subscribe" element={<SubscribePage />} />
        <Route path="/workspaces" element={<WorkspacesPage />} />
        <Route path="/vscode" element={<RemotePage />} />
        <Route path="/workspaces/:workspaceId" element={<WorkspaceDetailPage />} />
      </Routes>
      <InstallPrompt />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
